import { render } from "./ChargesContainer.vue?vue&type=template&id=8e886a12&ts=true"
import script from "./ChargesContainer.vue?vue&type=script&lang=ts"
export * from "./ChargesContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__